import { useCallback, useState } from 'react';
import { useHistory } from 'react-router-dom';

import { routes } from '../../../constants/routing';
import { IOneLink, OneLinkStatusEnum } from '../../../types/oneLink';

export const useOneLinksContextMenu = () => {
  const [menuAnchorEl, setMenuAnchorEl] = useState<null | HTMLElement>(null);
  const [selectedItem, setSelectedItem] = useState<IOneLink | null>(null);
  const history = useHistory();

  const handleMenuOpen = useCallback((event: React.MouseEvent<HTMLElement>, item: IOneLink) => {
    event.stopPropagation();
    setMenuAnchorEl(event.currentTarget);
    setSelectedItem(item);
  }, []);

  const handleMenuClose = useCallback(() => {
    setMenuAnchorEl(null);
    setSelectedItem(null);
  }, []);

  const handleRowClick = useCallback(
    (clickedItem: IOneLink | null) => {
      if (!clickedItem) {
        return;
      }

      history.push(
        routes.oneLinkManager.getOneLinkManagerUrl({
          itemId: clickedItem.uid,
          status: clickedItem.status as OneLinkStatusEnum,
        }),
      );
    },
    [history],
  );

  return {
    menuAnchorEl,
    selectedItem,
    handleMenuOpen,
    handleMenuClose,
    handleRowClick,
  };
};
